
export const GROUP_IN_STOCK = 'Group In Stock';
export const TRACKER = 'Tracker';
export const FC_INBOUND_HOME = 'FC Inbound Home';
export const DOCK_TO_STOCK = 'Dock-to-stock';
export const FC_INBOUND = 'FC Inbound';
export const TRACK_TRACE = 'Track & Trace';
export const OB_CARRIER_COMMUNICATION = 'OB Carrier Communication';
export const REPORTS_STACK = 'Reports Stack';
export const BEACON = 'Beacon';
export const LEAVE_FEEDBACK = 'Leave feedback';
export const REPORT_AN_ISSUE = 'Report an issue';
export const PUSH_FEEDBACK = 'PUSH_FEEDBACK';
export const REPORT_ISSUE = 'REPORT_ISSUE';
export const INSIGHT_IQ_ASSISTANT = 'InsightIQ Assistant';
export const DEFAULT = 'DEFAULT';
export const EXTERNAL_UNAUTHORIZED = "This page does not exist in Vision";
export const REACH_OUT = "If this is an error, please reach out to your contact at Sam's Club";
export const REQUEST_ACCESS = "Request a login from your contact at Sam's Club";
export const PLTFRM_UNAUTHORIZED = "You're not authorized to access Vision";
export const BACK = 'Go back';
export const PAGE_LOAD_ERR = "There's a problem loading this page";
export const TRY_AGN_LTR = 'Try again later';
export const INVALID = 'Invalid URL';
export const INTERNAL_UNAUTHORIZED = "Sorry, this address doesn't work. Take a look and try again?";
export const EVENTS_HOME_NAV_LABEL = 'Home';
export const GROUP_IN_STOCK_NAV_LABEL = 'In stock summary';
export const FC_INBOUND_HOME_NAV_LABEL = 'Home';
export const TRACKER_NAV_LABEL = 'Events Tracker';
